// @ts-nocheck
/* eslint-disable */
export const appChevronLeft24Icon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M15 7L9 12.5L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'chevron-left-24' as const
};